module.exports = __webpack_public_path__ + "static/assets/12b2583896feb0d3613f709a160ffb91.svg";